module.exports = __webpack_public_path__ + "static/media/meter3.19e4204d.svg";